// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-item {
  display: flex;
  align-items: flex-start;
  padding: 14px 16px;
  cursor: pointer;
  border-bottom: 1px solid #f3f4f6;
  transition: all 0.2s ease;
  position: relative;
  gap: 12px;
}
.notification-item:hover {
  background-color: #f8fafc;
  transform: translateX(2px);
}
.notification-item.unread {
  background: linear-gradient(to right, #eff6ff, #ffffff);
  border-left: 3px solid #3b82f6;
  padding-left: 13px;
}
.notification-item__icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  color: #0284c7;
  transition: all 0.2s ease;
}
.notification-item__icon .icon-task {
  color: #8b5cf6;
  background: linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%);
}
.notification-item__icon .icon-event {
  color: #f59e0b;
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
}
.notification-item__icon .icon-agreement {
  color: #3b82f6;
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
}
.notification-item__icon .icon-partner {
  color: #10b981;
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
}
.notification-item__icon .icon-meeting {
  color: #ec4899;
  background: linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%);
}
.notification-item__icon .icon-donation {
  color: #14b8a6;
  background: linear-gradient(135deg, #ccfbf1 0%, #99f6e4 100%);
}
.notification-item__icon .icon-campaign {
  color: #f97316;
  background: linear-gradient(135deg, #ffedd5 0%, #fed7aa 100%);
}
.notification-item__icon .icon-volunteer {
  color: #6366f1;
  background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
}
.notification-item__icon .icon-default {
  color: #6b7280;
  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
}
.notification-item__content {
  flex: 1;
  min-width: 0;
}
.notification-item__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 6px;
  gap: 8px;
}
.notification-item__title {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  margin: 0;
  line-height: 1.4;
  flex: 1;
}
.notification-item__time {
  font-size: 11px;
  color: #9ca3af;
  white-space: nowrap;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.notification-item__message {
  font-size: 13px;
  color: #6b7280;
  margin: 0;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.notification-item__indicator {
  position: absolute;
  right: 12px;
  top: 16px;
  width: 10px;
  height: 10px;
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(239, 68, 68, 0.3);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.1);
  }
}
[dir=rtl] .notification-item.unread {
  border-left: none;
  border-right: 3px solid #3b82f6;
  padding-left: 16px;
  padding-right: 13px;
}
[dir=rtl] .notification-item:hover {
  transform: translateX(-2px);
}
[dir=rtl] .notification-item__indicator {
  right: auto;
  left: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/notification-item/notification-item.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;AACF;AACE;EACE,yBAAA;EACA,0BAAA;AACJ;AAEE;EACE,uDAAA;EACA,8BAAA;EACA,kBAAA;AAAJ;AAGE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6DAAA;EACA,cAAA;EACA,yBAAA;AADJ;AAGI;EACE,cAAA;EACA,6DAAA;AADN;AAII;EACE,cAAA;EACA,6DAAA;AAFN;AAKI;EACE,cAAA;EACA,6DAAA;AAHN;AAMI;EACE,cAAA;EACA,6DAAA;AAJN;AAOI;EACE,cAAA;EACA,6DAAA;AALN;AAQI;EACE,cAAA;EACA,6DAAA;AANN;AASI;EACE,cAAA;EACA,6DAAA;AAPN;AAUI;EACE,cAAA;EACA,6DAAA;AARN;AAWI;EACE,cAAA;EACA,6DAAA;AATN;AAaE;EACE,OAAA;EACA,YAAA;AAXJ;AAcE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;AAZJ;AAeE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,OAAA;AAbJ;AAgBE;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AAdJ;AAiBE;EACE,eAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAfJ;AAkBE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,6DAAA;EACA,kBAAA;EACA,4CAAA;EACA,4BAAA;AAhBJ;;AAoBA;EACE;IACE,UAAA;IACA,mBAAA;EAjBF;EAmBA;IACE,YAAA;IACA,qBAAA;EAjBF;AACF;AAqBE;EACE,iBAAA;EACA,+BAAA;EACA,kBAAA;EACA,mBAAA;AAnBJ;AAsBE;EACE,2BAAA;AApBJ;AAuBE;EACE,WAAA;EACA,UAAA;AArBJ","sourcesContent":[".notification-item {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  padding: 14px 16px;\r\n  cursor: pointer;\r\n  border-bottom: 1px solid #f3f4f6;\r\n  transition: all 0.2s ease;\r\n  position: relative;\r\n  gap: 12px;\r\n\r\n  &:hover {\r\n    background-color: #f8fafc;\r\n    transform: translateX(2px);\r\n  }\r\n\r\n  &.unread {\r\n    background: linear-gradient(to right, #eff6ff, #ffffff);\r\n    border-left: 3px solid #3b82f6;\r\n    padding-left: 13px;\r\n  }\r\n\r\n  &__icon {\r\n    flex-shrink: 0;\r\n    width: 40px;\r\n    height: 40px;\r\n    border-radius: 10px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);\r\n    color: #0284c7;\r\n    transition: all 0.2s ease;\r\n\r\n    .icon-task {\r\n      color: #8b5cf6;\r\n      background: linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%);\r\n    }\r\n\r\n    .icon-event {\r\n      color: #f59e0b;\r\n      background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);\r\n    }\r\n\r\n    .icon-agreement {\r\n      color: #3b82f6;\r\n      background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);\r\n    }\r\n\r\n    .icon-partner {\r\n      color: #10b981;\r\n      background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);\r\n    }\r\n\r\n    .icon-meeting {\r\n      color: #ec4899;\r\n      background: linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%);\r\n    }\r\n\r\n    .icon-donation {\r\n      color: #14b8a6;\r\n      background: linear-gradient(135deg, #ccfbf1 0%, #99f6e4 100%);\r\n    }\r\n\r\n    .icon-campaign {\r\n      color: #f97316;\r\n      background: linear-gradient(135deg, #ffedd5 0%, #fed7aa 100%);\r\n    }\r\n\r\n    .icon-volunteer {\r\n      color: #6366f1;\r\n      background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);\r\n    }\r\n\r\n    .icon-default {\r\n      color: #6b7280;\r\n      background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);\r\n    }\r\n  }\r\n\r\n  &__content {\r\n    flex: 1;\r\n    min-width: 0;\r\n  }\r\n\r\n  &__header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: flex-start;\r\n    margin-bottom: 6px;\r\n    gap: 8px;\r\n  }\r\n\r\n  &__title {\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    color: #111827;\r\n    margin: 0;\r\n    line-height: 1.4;\r\n    flex: 1;\r\n  }\r\n\r\n  &__time {\r\n    font-size: 11px;\r\n    color: #9ca3af;\r\n    white-space: nowrap;\r\n    font-weight: 500;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.5px;\r\n  }\r\n\r\n  &__message {\r\n    font-size: 13px;\r\n    color: #6b7280;\r\n    margin: 0;\r\n    line-height: 1.5;\r\n    display: -webkit-box;\r\n    -webkit-line-clamp: 2;\r\n    line-clamp: 2;\r\n    -webkit-box-orient: vertical;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n\r\n  &__indicator {\r\n    position: absolute;\r\n    right: 12px;\r\n    top: 16px;\r\n    width: 10px;\r\n    height: 10px;\r\n    background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\r\n    border-radius: 50%;\r\n    box-shadow: 0 2px 4px rgba(239, 68, 68, 0.3);\r\n    animation: pulse 2s infinite;\r\n  }\r\n}\r\n\r\n@keyframes pulse {\r\n  0%, 100% {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n  50% {\r\n    opacity: 0.8;\r\n    transform: scale(1.1);\r\n  }\r\n}\r\n\r\n[dir='rtl'] .notification-item {\r\n  &.unread {\r\n    border-left: none;\r\n    border-right: 3px solid #3b82f6;\r\n    padding-left: 16px;\r\n    padding-right: 13px;\r\n  }\r\n\r\n  &:hover {\r\n    transform: translateX(-2px);\r\n  }\r\n\r\n  &__indicator {\r\n    right: auto;\r\n    left: 12px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
